'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'bicycle';
var width = 640;
var height = 512;
var aliases = [128690];
var unicode = 'f206';
var svgPathData = 'M339.5 32l116.5 0 0 16-91.5 0 85.2 184.6c14.4-5.6 30-8.6 46.3-8.6 70.7 0 128 57.3 128 128s-57.3 128-128 128-128-57.3-128-128c0-48.7 27.2-91 67.2-112.7l-26-56.3-90.1 172.7-2.2 4.3-45.1 0C267.6 427 212 480 144 480 73.3 480 16 422.7 16 352S73.3 224 144 224c13.5 0 26.5 2.1 38.7 5.9l31.9-61.1-27.5-56.9-59 0 0-16 69 0 2.2 4.5 28.8 59.5 170.6 0-53.8-116.6-5.2-11.4zM223.2 186.8l-82 157.2 158 0-76-157.2zm89.1 147.4l82.5-158.2-159.1 0 76.5 158.2zm176.5 21.2L441.9 253.9c-34.5 19.1-57.9 55.9-57.9 98.1 0 61.9 50.1 112 112 112s112-50.1 112-112-50.1-112-112-112c-13.9 0-27.3 2.5-39.6 7.2l46.8 101.5 3.4 7.3-14.5 6.7-3.4-7.3zM128 360l-13.2 0 6.1-11.7 54.2-103.9c-9.9-2.9-20.3-4.4-31.1-4.4-61.9 0-112 50.1-112 112S82.1 464 144 464c59.2 0 107.6-45.9 111.7-104L128 360z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faBicycle = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;